export type DocumentType = {
  id: string;
  name: string;
};

export const DocumentTypes: DocumentType[] = [
  { id: "c2243721-1252-486d-acc6-b0ec1a6a6c89", name: "AQIS/DAFF Inspection Certificate" },
  { id: "ca74dafb-2214-4d95-96fe-6e180ffd4ae9", name: "Beneficiary Certificate" },
  { id: "1ef593bf-2228-4cd6-b82f-587ecd492051", name: "Bill of Lading - Original" },
  { id: "812b9018-45c5-4bbf-8e7d-86f3d7b170d0", name: "Bill of Lading - Sea Waybill" },
  { id: "3ca51e48-8f91-48a4-9f2d-2307962307fd", name: "Booking Confirmation" },
  { id: "40c233c0-6180-4d7a-bde2-a8af2d8e938c", name: "Certificate of Aflatoxin" },
  { id: "ef5ef619-efc9-4efc-8b73-c26c29415d0b", name: "Certificate of Analysis" },
  { id: "3bb0d96c-02e5-44cc-bf32-52901c1b597b", name: "Certificate of Laboratory" },
  { id: "032ca520-2360-409e-ba10-eac4d46fd5a0", name: "Certificate of Origin" },
  { id: "85900ed5-f17a-4aa7-910a-54fffec4dd3f", name: "Certificate of Quality" },
  { id: "17cbeb08-08a1-4610-85e6-dd9ffcf12f67", name: "Certificate of Weight" },
  { id: "1c72425e-8184-4829-bc5c-e66daaf69a3d", name: "Chemical Residues Certificate" },
  { id: "d07fd125-dc33-4181-9421-a91679c9af04", name: "Commercial Invoice" },
  { id: "047414ec-cafa-4dc4-af17-ba98c5877d4d", name: "Commoditiy Inspection Certificate" },
  { id: "9512be3b-a5d9-494d-b99c-8a87d83439cf", name: "Container Cleanliness Certificate" },
  { id: "f1de8663-de5c-4d44-891f-7edb02fc06f9", name: "Courier Receipt" },
  { id: "c60f4a8e-61e0-4eb7-9834-0d34cd9c3ecd", name: "Courier Waybill" },
  { id: "1c63c519-d7a9-46b7-babd-4372790abe32", name: "Cover letter Frey - CAD bank" },
  { id: "55097212-5674-4636-a39a-d06966a4e7f0", name: "Cover letter Frey - LC" },
  { id: "db93039f-31c6-469e-80c5-7cf2d796ca34", name: "Cover letter from Bank - CAD bank" },
  { id: "49839b53-e788-4dbe-b5a8-fda3f665a8ec", name: "Cover letter from Bank - LC" },
  { id: "b6257e15-8772-4f0e-a377-eb5850a861ae", name: "Crop Year Certificate" },
  { id: "a299e1b0-48a4-4e42-9cd9-1ec2db1427e1", name: "Declaration Statement" },
  { id: "24425b4d-32c1-4b0e-8f99-648c32aa6f28", name: "Document instructions" },
  { id: "2f07950b-37fb-432d-abe5-0403c0217a73", name: "Draft Drawn" },
  { id: "f688e427-c6a3-4779-b9e5-f4e8c7638977", name: "Ethylene Oxide Free Beneficiary Certificate" },
  { id: "20c67ad3-f947-4d3c-a3ae-9819641dab7c", name: "Export Certificate for Animal Products" },
  { id: "8f58856c-8968-4fab-b746-6536920825cc", name: "Export Inspection Certificate" },
  { id: "b7cf6cc1-a31b-41af-8d3f-2481927b977c", name: "FGIS-921-2" },
  { id: "ef028269-fcbc-4b27-9a36-0f86eed72dd9", name: "Freight Certificate" },
  { id: "4cce9c98-8935-4f95-8c7e-0260adaaf6a1", name: "Fumigation Certificate" },
  { id: "e23f94b5-d648-43e8-bc0c-3a41a1d65221", name: "Fumigation in bins" },
  { id: "cdf3c4da-0599-4c09-9dbc-100b998bf66f", name: "GMO Certificate with events" },
  { id: "7b1b6167-3412-469c-91f8-980efa6d5dfc", name: "GMO Certificate without events" },
  { id: "2fcc75c1-c971-43c5-b9b8-6cb29a488e26", name: "GMP + B3 Certificate" },
  { id: "f93fce0d-0294-422f-98f1-e18cc2a57094", name: "Grade Certificate" },
  { id: "3b897162-62aa-429d-be39-d6a5e7a18c65", name: "Halal Certificate" },
  { id: "3412ad30-5cf6-4a53-af7e-5f804f183d11", name: "Health Certificate" },
  { id: "76fdfb08-4bff-4be4-8a25-cf0821d909e6", name: "Heavy Metals Certificate" },
  { id: "663ab2d1-6e6c-41c1-9822-43733fe54ca9", name: "Human Consumption Certificate" },
  { id: "661228f1-bbeb-474f-8ca8-a86fe1156c73", name: "I-106 Form" },
  { id: "70f8c990-f92b-4759-ae49-83cd55d9e38c", name: "Import Permit" },
  { id: "cbc650bb-72e3-4d4d-ba69-bef57e24da55", name: "Independent Certificate" },
  { id: "2e75ba33-0b06-46f7-ae21-329b6a0a9dad", name: "Insurance Certificate" },
  { id: "e8b7af65-1e9f-45b3-ba93-9a7d4872773e", name: "Intertek Analysis Request" },
  { id: "edf8261b-1a53-434d-b02a-41870bbd588b", name: "Labelling Statement" },
  { id: "41fc45c8-9e7a-4cec-a17f-336d3138c69d", name: "Letter of Analysis: Vomitoxin" },
  { id: "565e5d7c-ee25-4e1c-b33f-85178bc955ce", name: "Loading instructions" },
  { id: "a75591cd-c40e-445c-b07f-ab1536b32b23", name: "Microbiology Certificate" },
  { id: "a5841832-d011-41b8-9899-064c7e259b0d", name: "Mycotoxin and Aflatoxin Certificate" },
  { id: "90415825-3d6e-43c7-aa66-5852b9839e71", name: "Mycotoxin Certificate" },
  { id: "7926a091-f573-4194-8970-d127636660d1", name: "Non-GMO Certificate" },
  { id: "fe17393d-64ba-4c17-af73-ba4306d106d4", name: "Non-Radioactivity Certificate" },
  { id: "f37c26c1-7c55-40dd-9a67-01e745fc4f55", name: "Non-Wood Packing Certificate" },
  { id: "9e60a6c2-3ffc-443f-a5cc-ee3f12b84a11", name: "Official Export Grain Inspection" },
  { id: "1cdb51d9-594f-41d3-aa5f-fcc03788dfcd", name: "Packing Instructions" },
  { id: "cae813d5-d91c-4d90-b6c4-6901298093a0", name: "Packing List" },
  { id: "4daf4126-e668-4c59-a324-fc5679564c22", name: "Pesticide Certificate" },
  { id: "b1999a76-27f1-4ca3-9af2-34c38b002b68", name: "Phytosanitary Certificate" },
  { id: "3d8cbf7c-ddc5-44a8-8f6d-7e4291827fbd", name: "Prior Notice" },
  { id: "ba898b2a-f115-4a02-89be-42b8537d229b", name: "Proforma invoice" },
  { id: "6d3c9cfa-ddfd-444f-b0f3-b5aa2ac4c3d5", name: "Radiation Certificate" },
  { id: "37d31cdf-649f-4b66-be73-24ab93cfa624", name: "Radioactivity Certificate" },
  { id: "c5a7faa1-8c57-452c-9bb0-34fb55cc14e4", name: "Railcar Order" },
  { id: "9206376d-f129-4565-938a-66d6812cddcb", name: "Railcar Variance" },
  { id: "06626c59-e968-4c35-9e42-53f6d573bca1", name: "Relationship Statement Letter" },
  { id: "b8a2c1da-b49d-4baf-9b2d-5ae605c23065", name: "Sample Submission Form" },
  { id: "078638b6-6d2f-4d20-9e60-573019a6485f", name: "SGS Form" },
  { id: "e052a6e1-46cd-4480-8f5b-e9e922e97c3b", name: "Shipping Certificate" },
  { id: "6535e992-93f3-43e6-af3d-fecf790f65ae", name: "Shipping instructions" },
  { id: "6cb01c3e-114e-4a0b-b21d-edc5dccf99c4", name: "Soybean Export Sustainability Certificate" },
  { id: "ee90c8ce-0b4e-4d0b-85d8-cfebe683a67c", name: "Statement Letter" },
  { id: "7d6e5ad2-676e-4eb3-b408-bac03cdd572d", name: "Statement of Assurance “No Transgenic Varieties”" },
  { id: "3c28d41e-ae2a-4390-b287-3c107d306424", name: "Statement of Assurance for Glyphosate" },
  { id: "97ba9865-b65d-4df5-ba79-d8b4a42cbb1f", name: "Statement of Assurance for Radioactivity" },
  { id: "46155be6-bdbe-45ad-98de-27375238cce6", name: "Statement of Assurance Request" },
  { id: "3486522c-59c5-43c0-927f-97abf1f0db53", name: "Statement of Assurance: Aflatoxin and Ochratoxin A" },
  { id: "1ba1d4cf-81e1-4dcc-9551-6fb7c41886fd", name: "Statement of Assurance: Canadian Origin" },
  { id: "a176db6e-4637-412b-8083-7efd30e15919", name: "Statement of Assurance: Human Consumption" },
  { id: "e0d43bee-08a8-4859-bf19-2cba57afa4ed", name: "Statement of Assurance: Karnal Bunt" },
  { id: "6bb3f915-a3e6-4acc-95ad-762b76952289", name: "Statement of Assurance: Mycotoxins" },
  { id: "fbd62442-4b1f-4a99-bfbe-3678985815d2", name: "Statement of Assurance: Non-GMO" },
  { id: "2d363985-d292-4156-81c0-897b57a17fda", name: "Statement of Assurance: Pesticides Residue" },
  { id: "bf3f5a8b-2990-4b1d-a861-179a3af6983a", name: "Statement of Assurance: Radionuclides" },
  { id: "60488294-95aa-4c95-bbf3-11a2b7351d2d", name: "Statement of Assurance: Zearalenone" },
  { id: "08a07e4d-4b25-49ec-9151-db24a4c7ce3f", name: "Stowage Certificate" },
  { id: "da876861-9754-44b1-8d7d-24da1de388fd", name: "Stuffing instructions" },
  { id: "c4528b47-37ba-435d-a539-297287eb17d8", name: "Titanium Dioxide Free Beneficiary Certificate" },
  { id: "566a7f95-90f3-4c89-81c0-efe5ce2f249d", name: "Verified Gross Mass (VGM)" },
  { id: "336c1607-dca1-49b9-9462-36855d8ee2a2", name: "Vomitoxin Certificate" },
  { id: "f576b1d7-893e-46eb-acf3-2374dbbade14", name: "White Certificate" },
  { id: "571d3d82-17ec-4a9d-967c-91e76bf499e4", name: "Wood Packing Certificate" },
];
